import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import TodayTab from './TodayTab';
import TrendsTab from './TrendsTab';
import WorkoutsTab from './WorkoutsTab';
import LabsTab from './LabsTab';
import HealthSettingsTab from './HealthSettingsTab';

const HealthManager = () => {
  const [key, setKey] = useState('today');

  return (
    <div className="pt-2">
      <Tabs id="health-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
        <Tab eventKey="today" title="Daily Log">
          <TodayTab />
        </Tab>
        <Tab eventKey="trends" title="Trends">
          <TrendsTab />
        </Tab>
        <Tab eventKey="workouts" title="Workouts">
          <WorkoutsTab />
        </Tab>
        <Tab eventKey="labs" title="Labs">
          <LabsTab />
        </Tab>
        <Tab eventKey="settings" title="Settings">
          <HealthSettingsTab />
        </Tab>
      </Tabs>
    </div>
  );
};

export default HealthManager;
